import React from "react";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom"; // ✅ React Router for navigation
import AssessmentSetup from "./pages/assessment/AssessmentSetup";
import AssessmentPage from "./pages/assessment/AssessmentPage";
import AssessmentList from "./pages/assessment/AssessmentList";

import Results from "./components/assessment/Results";
import Layout from "./components/layout/DefaultLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./pages/home/HomePage";
import QuestionsReviewApp from "./components/QuestionReview";
import ChapterConceptAssignment from "./components/concept/ConceptChapterAssignment";
import ConceptManager from "./components/concept/ConceptManager";
import AdminDashboard from "./pages/dashboard/AdminDashboard";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<Layout />} />
        <Route
          path="/assessments"
          element={
            <ProtectedRoute>
              <AssessmentList />
            </ProtectedRoute>
          }
        />

        <Route
          path="/assessment-setup"
          element={
            <ProtectedRoute>
              <AssessmentSetupWrapper />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Chapters"
          element={
            <ProtectedRoute>
              <ChapterConceptAssignment />
            </ProtectedRoute>
          }
        />

        <Route
          path="/concepts"
          element={
            <ProtectedRoute>
              <ConceptManager />
            </ProtectedRoute>
          }
        />

        <Route
          path="/assessment"
          element={
            <ProtectedRoute>
              <AssessmentPageWrapper />
            </ProtectedRoute>
          }
        />

        <Route
          path="/questionpaper"
          element={
            <ProtectedRoute>
              <QuestionPaperWrapper />
            </ProtectedRoute>
          }
        />

        <Route
          path="/results"
          element={
            <ProtectedRoute>
              <Results />
            </ProtectedRoute>
          }


        />

        <Route
          path="/questions-review"
          element={
            <ProtectedRoute>
              <QuestionsReviewApp />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

const AssessmentSetupWrapper = () => {
  const navigate = useNavigate();

  const handleStartAssessment = (subject, chapters) => {
    navigate("/assessment", { state: { subjectName: subject, chapterNames: chapters } });
  };

  const handleViewQuestionPaper = (subject, chapters) => {
    navigate("/questionpaper", { state: { subjectName: subject, chapterNames: chapters } });
  };

  return <AssessmentSetup onStartAssessment={handleStartAssessment} onViewQuestionPaper={handleViewQuestionPaper} />;
};

const AssessmentPageWrapper = () => {
  const location = useLocation();
  const assessmentConfig = location.state || {}; // ✅ Directly retrieve navigation state

  return <AssessmentPage assessmentConfig={assessmentConfig} />;
};

const QuestionPaperWrapper = () => {
  const location = useLocation();
  const assessmentConfig = location.state || {}; // ✅ Retrieve navigation state properly for question paper view

  return <AssessmentPage assessmentConfig={assessmentConfig} isQuestionPaperView={true} />;
};

export default App;
